module.exports = __webpack_public_path__ + "ff9c28732e085e811514c0a2a86640fc.svg";